import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputAdornment from '@mui/material/InputAdornment';
import LOOKUP from 'constants/lookup';
import { getEmployees, resetPassword, getRoles, changeEmployeePassword } from 'actions/EntityActions';
import { resetPasswordResult, clearFormInput, clearEmployeeChangePasswordForm } from 'actions/FormActions';
import { showSnackbar, showError } from 'actions/CommonActions';
import { employeeListCrumb } from 'utils/breadcrumbInfo';
import { mapRoles, mapEmployeeList } from 'utils/mappers';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import GenericTable from 'screens/components/advanced/GenericTable';

import SearchFields from './Components/searchFields';
import WithRouter from 'custom/withRouter';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import ExcelUploadEmployee from 'screens/components/basic/ExcelUploadEmployee'

const pageName = "employeeList";
const name = "employee";

class EmployeeList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            status: 'None',
            orderBy: 'DESC',
            sortBy: 'Id',
            showDialogPWreset: false,
            resetPwUsername: "",
            resetPwName: "",
            resetPwEmployeeRole: ""
        };
        this.pwdRef = React.createRef();
        this.confirmPwdRef = React.createRef();

        this.sort = this.sort.bind(this);
        this.search = this.search.bind(this);
        this.cleanSearch = this.cleanSearch.bind(this);
        this.editEmployee = this.editEmployee.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.showDialogPWreset = this.showDialogPWreset.bind(this);
        this.closeDialogPWreset = this.closeDialogPWreset.bind(this);
        this.changePage = this.changePage.bind(this);
    }

    componentWillMount() {
        this.cleanSearch();
        this.props.getRoles();
    }

    componentWillUnmount = () => {
        this.cleanSearch();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.employeePasswordResetTimeStamp && this.props.employeePasswordResetTimeStamp !== newProps.employeePasswordResetTimeStamp) {
            if (newProps.employeePasswordResetSuccess === true) {
                this.resetPasswordSuccess();
            }
            else if (newProps.employeePasswordResetSuccess === false) {
                this.resetPasswordFailure();
            }
        }
        if (newProps.employeePasswordChangeSaveTimeStamp && this.props.employeePasswordChangeSaveTimeStamp !== newProps.employeePasswordChangeSaveTimeStamp) {
            if (newProps.employeePasswordChangeSuccess === true) {
                this.changePasswordSuccess();
            }
            else if (newProps.employeePasswordChangeSuccess === false) {
                this.changePasswordFailure();
            }
        }
    }

    getEmployees() {
        this.props.init({
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            firstName: this.props.firstNameFilter ? this.props.firstNameFilter : "",
            lastName: this.props.lastNameFilter ? this.props.lastNameFilter : "",
            id: 0,
            BranchId: this.props.employeeBranchId ? this.props.employeeBranchId : this.props.branchId,
            role: this.props.employeeListRoleFilter != "0" ? this.props.employeeListRoleFilter : "",
            status: this.props.employeeListStatus ? this.props.employeeListStatus : "None",
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy
        })
    }

    resetPasswordSuccess() {
        this.props.showSnackbar(LOOKUP.authentication.resetPasswordSuccessMessage);
        this.props.resetPasswordResult();
    }

    resetPasswordFailure() {
        this.props.showError(LOOKUP.authentication.resetPasswordErrorMessage);
    }

    resetPassword() {
        this.props.resetPassword(this.state.resetPwUsername);
        this.closeDialogPWreset();
    }

    changePassword() {
        const changePasswordModel = {
            UserName: this.state.resetPwUsername,
            NewPassword: this.props.employeePwd
        };
        this.props.changePassword(changePasswordModel);
    }

    changePasswordSuccess() {
        this.props.showSnackbar(LOOKUP.authentication.changeEmployeePasswordSuccessMessage);
        this.closeDialogPWreset();
    }

    changePasswordFailure() {
        this.props.showError(LOOKUP.authentication.changeEmployeePasswordErrorMessage);
    }

    showDialogPWreset(username, name, role) {
        this.setState({ showDialogPWreset: true, resetPwUsername: username, resetPwName: name, resetPwEmployeeRole: role });
    }

    closeDialogPWreset() {
        this.setState({ showDialogPWreset: false, resetPwUsername: "", resetPwName: "", resetPwEmployeeRole: "" });
        this.props.clearEmployeeChangePasswordForm();
    }

    isPwdValid() {
        let pwdField = document.getElementById("employeepwd");
        if (pwdField) {
            return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}/.test(this.props.employeePwd);
        }
        return true;
    }

    isPwdMatched() {
        if (this.props.employeePwdConfirm == this.props.employeePwd) {
            return true;
        }
        return false;
    }

    togglePwd() {
        const pwd = this.pwdRef.current;
        if (pwd && pwd.type) {
            pwd.type = pwd.type === "password" ? "text" : "password";
        }
    }

    toggleConfirmPwd() {
        const confirmPwd = this.confirmPwdRef.current;
        if (confirmPwd && confirmPwd.type) {
            confirmPwd.type = confirmPwd.type === "password" ? "text" : "password";
        }
    }

    editEmployee(id) {
        this.props.navigate(`/employee/edit/${id}`);
    }

    addEmployee() {
        this.props.navigate(`/employee/add`);
    }

    changePage(e) {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getEmployees);
    }

    search() {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getEmployees);
    }

    cleanSearch() {
        this.props.clearFormInput(`${pageName}RoleFilter`);
        this.props.clearFormInput(`${pageName}FisrtNameFilter`);
        this.props.clearFormInput(`${pageName}LastNameFilter`);
        this.props.clearFormInput(`${pageName}Status`);
        this.props.clearFormInput(`${pageName}BranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "Id",
                orderBy: "DESC"
            };
        }, () => this.getEmployees());
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getEmployees);
    }

    downloadEmployeeTemplate = () => {
        window.location.href = this.props.apiURL + `unauthorized/dlEmployeetemplate`;
    }

    render() {
        const p = this.props;
        const s = this.state;

        return (
            <Grid headerContent={employeeListCrumb}>
                <PageHeaderWithButton title={LOOKUP.employee.listTitle}>
                    <Button
                        type="AddButton"
                        mini={true}
                        label="ADD NEW EMPLOYEE"
                        className="bg-light-green"
                        onTouchTap={() => this.props.navigate("/employee/add")} />
                    &nbsp;
                    <Button
                        mini={true}
                        label="DOWNLOAD Eployee TEMPLATE"
                        className="bg-gray-Purple-p POListBtn mr-1 btnNewBrandPOS"
                        onTouchTap={this.downloadEmployeeTemplate}
                    />
                    <ExcelUploadEmployee />
                </PageHeaderWithButton>
                <SearchFields
                    branchOptions={this.props.branchOptions}
                    pageName={pageName}
                    cleanSearch={this.cleanSearch}
                    search={this.search}
                    add={this.addEmployee}
                    roles={mapRoles(this.props.rolesList)}
                    loggedBranch={this.props.branchId}
                />
                <section>
                    <CardSimple>
                        <GenericTable
                            className="table_center tableHeaderwhiteColorFont"
                            tableBodyClassName="patients-table"
                            multiSelectable={false}
                            enableSelectAll={false}
                            selectable={false}
                            columns={LOOKUP.employee.tableColumns}
                            rows={mapEmployeeList(p.employees, this.editEmployee, this.showDialogPWreset, this.props.canUpdateEmployee)}
                            orderBy={this.state.orderBy}
                            sortBy={this.state.sortBy}
                            sort={this.sort}
                            stripedRows={true}
                        />
                        <Pagination
                            length={p.employeesLength || 0}
                            itemsPerPage={s.itemsPerPage}
                            activePage={s.activePage}
                            onPageChange={this.changePage}
                            maxButtons={4} />
                    </CardSimple>
                </section>
                <DialogInput
                    title={<DialogHeaderWithClose text={`Reset Password for ${this.state.resetPwName}`} handleClose={() => this.closeDialogPWreset()} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogPWreset()} />,
                        <Button className="pull-right btnNewBrandPOS"
                            label={LOOKUP.employee.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.changePassword()}
                            disabled={!this.isPwdValid() || !this.isPwdMatched() || !this.props.canUpdateEmployee}
                        />]}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.showDialogPWreset}>
                    <div className="row pull-right">
                        <Button className="pull-right btnNewBrandPOS"
                            label="Or reset directly through email"
                            primary onTouchTap={() => this.resetPassword()} />
                    </div>
                    <div className="col-lg-6">Enter new password below:</div>

                    <div className="col">
                        <div className="row ">
                            <div className="col-lg-6 position-relative">
                                <TextInput
                                    inputRef={this.pwdRef}
                                    name={name + 'Password'}
                                    id={name + 'pwd'}
                                    type={'password'}
                                    label="New Password"
                                    className="pull-left"
                                    floatingLabelText="New Password"
                                    hintText="New Password"
                                    maxLength={20}
                                    endAdornment={
                                        <InputAdornment position="end" onClick={() => this.togglePwd()}>
                                            <i className="fa fa-eye pull-left employee_password_toggle" aria-hidden="true" />
                                        </InputAdornment>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-10">
                            {
                                (this.props.employeePwd == '' || this.isPwdValid())
                                    ? '' : <div className="pwd_validation"><p
                                        className="employee_password_validation">Password does not match the
                                        requirements</p></div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-lg-6 position-relative">
                                <TextInput
                                    inputRef={this.confirmPwdRef}
                                    name={name + 'PasswordConfirm'}
                                    id={name + 'PwdConfirm'}
                                    type={'Password'}
                                    label="Confirm Password"
                                    className="pull-left"
                                    floatingLabelText="Confirm Password"
                                    hintText="Confirm Password"
                                    maxLength={20}
                                    fullWidth={false}
                                    endAdornment={
                                        <InputAdornment position="end" onClick={() => this.toggleConfirmPwd()}>
                                            <i className="fa fa-eye pull-left employee_password_toggle" aria-hidden="true" />
                                        </InputAdornment>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-10">
                            {
                                this.props.employeePwdConfirm == undefined || this.props.employeePwdConfirm == ''
                                    ? '' : this.props.employeePwd == '' && this.props.employeePwdConfirm
                                        ? <div className="pwd_validation"><p
                                            className="employee_password_validation">Please enter the new password
                                            first</p></div> : this.isPwdMatched()
                                            ? '' : <div className="pwd_validation"><p
                                                className="employee_password_validation">Password does not match</p>
                                            </div>
                            }
                        </div>
                    </div>
                    <br></br>
                    <div className="employee_pw_msg">
                        <p>Password must:</p>
                        <div>
                            <li>Have between 8 and 20 characters</li>
                            <li>Contain at least a number</li>
                            <li>Contain at least an uppercase character</li>
                            <li>Contain at least a special character</li>
                        </div>
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    brachOptions.push({ text: "All", value: "0" });
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        employees: state.entity.employeeList,
        employeesLength: state.entity.employeeListLength,
        employeePasswordResetSuccess: state.form.employeePasswordResetSuccess,
        employeePasswordResetTimeStamp: state.form.employeePasswordResetTimeStamp,
        employeePasswordChangeSuccess: state.form.employeePasswordChangeSuccess,
        employeePasswordChangeSaveTimeStamp: state.form.employeePasswordChangeSaveTimeStamp,
        branchId: state.common.branchId,
        firstNameFilter: state.form[`${pageName}FisrtNameFilter`],
        lastNameFilter: state.form[`${pageName}LastNameFilter`],
        employeeListStatus: state.form[`${pageName}Status`],
        employeeListRoleFilter: state.form[`${pageName}RoleFilter`],
        employeeBranchId: state.form[`${pageName}BranchOption`],
        rolesList: state.entity.rolesList,
        branchOptions: brachOptions,
        employeePwd: state.form["employee" + "Password"],
        employeePwdConfirm: state.form["employee" + "PasswordConfirm"],
        canUpdateEmployee: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanUpdateEmployee")),
        apiURL: state.common.store.apiUrl
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (page, itemsPerPage, branchId) => dispatch(getEmployees(page, itemsPerPage, branchId)),
        resetPassword: (employeeId) => dispatch(resetPassword(employeeId)),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        resetPasswordResult: () => dispatch(resetPasswordResult()),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getRoles: () => dispatch(getRoles()),
        changePassword: (model) => dispatch(changeEmployeePassword(model)),
        clearEmployeeChangePasswordForm: () => dispatch(clearEmployeeChangePasswordForm())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(EmployeeList));
